<template>
  <div style="margin: 0 48px 8px 24px;">
    <el-form ref="formRef" :model="timeForm" label-width="auto" label-position="right">
      <el-form-item label="营业日：" v-if="type == 1">
        <el-select v-model="timeForm.startNum" placeholder="开始" class="select-item"  style="width: 100%;">
          <el-option v-for="item in weekArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <span style="margin: 0 8px"> - </span>
        <el-select v-model="timeForm.endNum" placeholder="结束" class="select-item"  style="width: 100%;">
          <el-option v-for="item in weekArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="营业时间：">
        <div style="display: flex">
          <el-time-picker v-model="timeForm.startTime" style="width: 100%;" placeholder="开始" format="HH:mm" value-format="HH:mm"/>
          <span style="margin: 0 8px"> - </span>
          <el-time-picker v-model="timeForm.endTime" style="width: 100%;" placeholder="结束" format="HH:mm" value-format="HH:mm"/>
        </div>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData, imgPostFormData } from "@/api/api"
import { addOrUpdateBusinessHours, delBusinessHours } from "@/api/url";
import { phoneReg } from "@/assets/shared/reg-constant";
import Dialog from "@/assets/js/dialog";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      timeForm: this.value.timeForm,
      idx: this.value.ids,
      type: this.value.type,
      shopId: this.value.shopId,

      weekArray: [
        {label: '周一', value: 1},
        {label: '周二', value: 2},
        {label: '周三', value: 3},
        {label: '周四', value: 4},
        {label: '周五', value: 5},
        {label: '周六', value: 6},
        {label: '周日', value: 7},
      ],

      timeArray: [],
    }
  },
  methods: {

    cancel() {
      this.$emit("close");
    },
    summit() {
      if(!this.timeForm.startNum || !this.timeForm.endNum) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '营业日不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.timeForm.startTime || !this.timeForm.endTime) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '营业时间不能为空',
          type: 'warning'
        });
        return false
      }
      let param = {}
      param['id'] = this.idx > -1?this.timeForm.id:0;
      param['shopId'] = this.shopId;
      param['startNum'] = this.timeForm.startNum;
      param['endNum'] = this.timeForm.endNum;
      param['startTime'] = this.timeForm.startTime;
      param['endTime'] = this.timeForm.endTime;

      postFormData(addOrUpdateBusinessHours, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

  },
  mounted() {
    if(this.type == 2) {
      this.timeForm.startNum = 8
      this.timeForm.endNum = 8
    }
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  margin: 0 auto
}
.delBtn {
  background-color: #bbbbbb;
  color: #ffffff;
  height: 18px;
  width: 18px;
  border-radius: 9px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  line-height: 10px;
  cursor: pointer;
  flex-shrink: 0;
  margin-right: 12px;
}
.delBtn:hover {
  background-color: red;
}
.time-box {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 16px;
  background-color: #f6f6f6;
  margin-top: 12px;
  border-radius: 8px;
}
.time-box span {
  white-space: nowrap;
}
.time-box-item {
  display: flex;
  align-items: center;
}
</style>
